import { type FC, Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import { Loader, LoaderMode } from "components/Loader/Loader";
import { Page } from "pages";

const Element = lazy(async () => await import("../../components/AbnSoleTraderRegisterForm/AbnSoleTraderRegisterForm"));

export const AbnSoleTraderFormRoutes: FC = () => (
  <Routes>
    <Route
      index
      path="*"
      element={
        <Suspense fallback={<Loader size="xxl" mode={LoaderMode.Splashscreen} />}>
          <Element path={Page.SoleTrader} />
        </Suspense>
      }
    />
  </Routes>
);
